export const landing = {
  /** Split so the closer can be picked out in the brand lime. */
  headline: {
    before: "If we can't save you money ",
    highlight: "it's free",
  },
  stats: {
    upfront: { value: "$0", label: "Upfront cost" },
    savings: { value: "75%", label: "Average savings" },
    rating: { value: "4.9", label: "App Store rating" },
  },
  trust: "HIPAA secure · Sign up in 5 minutes",
} as const;

export const copy = {
  bill: {
    title: "Do you have a bill?",
    yes: "Yes",
    save: "No, but I'd like to save on future bills",
  },
  natera: {
    title: "Is your bill from Natera?",
    yes: "Yes",
    no: "No",
  },
  stress: {
    title: "How stressed are you about this bill?",
    aLot: "A lot",
    aLittle: "A little",
    notReally: "Not really",
  },
  feeling: {
    title: "What concerns you about this bill?",
    confused: "I don't understand the charges",
    blindsided: "It's unexpected",
    worried: "I can't afford it",
    ready: "I just want it handled",
  },
  validation: {
    confused: {
      title: "We'll get to the bottom of this",
      body: "Medical bills are genuinely hard to read. We'll break down the charges and work to lower what you owe.",
    },
    blindsided: {
      title: "We'll get to the bottom of this",
      body: "Bills like this tend to show up unannounced. We'll find out where this one came from — and whether you should owe it at all.",
    },
    worried: {
      title: "We can help bring it down",
      body: "The statement price is a starting point. Between income-based discounts and negotiating, most bills end up far lower.",
    },
    ready: {
      title: "Let us take care of this for you",
      body: "We'll take it from here — no calls, no chasing, no hold music.",
    },
    caption: "We'll set up your account next.",
    cta: "Get started",
  },
  save: {
    headline: {
      before: "Granted ",
      highlight: "saves you money",
      after: " on future healthcare bills",
    },
    subhead: {
      before: "Connect your insurance and ",
      highlight: "never guess whether a bill is right again.",
    },
    cta: "Sign up today",
  },
} as const;
